// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointBenchmarkFromJSON, DatapointBenchmarkToJSON, DatapointContextFromJSON, DatapointContextToJSON, DatapointIdFromJSON, DatapointIdToJSON, } from './';
export function DatapointFromJSON(json) {
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'datapoint': DatapointIdFromJSON(json['datapoint']),
        'format': !exists(json, 'format') ? undefined : json['format'],
        'timeseries': !exists(json, 'timeseries') ? undefined : json['timeseries'],
        'benchmark': !exists(json, 'benchmark') ? undefined : DatapointBenchmarkFromJSON(json['benchmark']),
        'periods': !exists(json, 'periods') ? undefined : json['periods'],
        'projected': !exists(json, 'projected') ? undefined : json['projected'],
        'performancePeriod': !exists(json, 'performancePeriod') ? undefined : json['performancePeriod'],
        'context': !exists(json, 'context') ? undefined : DatapointContextFromJSON(json['context']),
    };
}
export function DatapointToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'datapoint': DatapointIdToJSON(value.datapoint),
        'format': value.format,
        'timeseries': value.timeseries,
        'benchmark': DatapointBenchmarkToJSON(value.benchmark),
        'periods': value.periods,
        'projected': value.projected,
        'performancePeriod': value.performancePeriod,
        'context': DatapointContextToJSON(value.context),
    };
}
/**
* @export
* @enum {string}
*/
export var DatapointFormatEnum;
(function (DatapointFormatEnum) {
    DatapointFormatEnum["Percent"] = "percent";
    DatapointFormatEnum["Variation"] = "variation";
    DatapointFormatEnum["WeightedAverage"] = "weightedAverage";
    DatapointFormatEnum["PercentOfTotal"] = "percentOfTotal";
    DatapointFormatEnum["SimpleAverage"] = "simpleAverage";
    DatapointFormatEnum["WeightedAverageByIC"] = "weightedAverageByIC";
})(DatapointFormatEnum || (DatapointFormatEnum = {}));
/**
* @export
* @enum {string}
*/
export var DatapointTimeseriesEnum;
(function (DatapointTimeseriesEnum) {
    DatapointTimeseriesEnum["EndOfQuarter"] = "EndOfQuarter";
    DatapointTimeseriesEnum["EndOfYear"] = "EndOfYear";
    DatapointTimeseriesEnum["YearOverYear"] = "YearOverYear";
})(DatapointTimeseriesEnum || (DatapointTimeseriesEnum = {}));
/**
* @export
* @enum {string}
*/
export var DatapointPerformancePeriodEnum;
(function (DatapointPerformancePeriodEnum) {
    DatapointPerformancePeriodEnum["Itd"] = "Itd";
    DatapointPerformancePeriodEnum["Ytd"] = "Ytd";
    DatapointPerformancePeriodEnum["OneQuarter"] = "OneQuarter";
    DatapointPerformancePeriodEnum["SixMonths"] = "SixMonths";
    DatapointPerformancePeriodEnum["OneYear"] = "OneYear";
    DatapointPerformancePeriodEnum["TwoYears"] = "TwoYears";
    DatapointPerformancePeriodEnum["ThreeYears"] = "ThreeYears";
    DatapointPerformancePeriodEnum["FiveYears"] = "FiveYears";
    DatapointPerformancePeriodEnum["TenYears"] = "TenYears";
})(DatapointPerformancePeriodEnum || (DatapointPerformancePeriodEnum = {}));
